import { render, staticRenderFns } from "./sider-menu.vue?vue&type=template&id=07569a2d&"
import script from "./sider-menu.vue?vue&type=script&lang=js&"
export * from "./sider-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports